import '@github/relative-time-element';
import ButtonFlat from '../../../ButtonWrapper/components/ButtonFlat';
import { __ } from '@wordpress/i18n';
import StatusIconComponent from '../../../StatusIconComponent';
import dateToISO from '../../../../helpers/dateToISO';

const ActionItem = ({ data }) => {
    return (
        <li>
            <StatusIconComponent status={data.status}/>
            <div>
                <span>{data.title}</span>
                <relative-time datetime={dateToISO(data.date)}/>
            </div>
            <ButtonFlat size="sm">{__('Verifica', 'soundbetween')}</ButtonFlat>
        </li>
    )
}

export default ActionItem;